import type { JSX } from 'react'

export const BundleCover3 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_628_279)'>
      <rect width='1920' height='1080' fill='#161616' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M914.637 1012.92C1199.62 705.869 1504.46 419.367 1749.38 203.162C1810.08 149.576 1867.03 100.373 1919 56.3105V0H1738.75C1708.18 26.418 1676.37 54.1953 1643.49 83.2129C1395.79 301.883 1086.88 592.131 797.363 904.078C737.023 969.092 680.066 1027.65 626.634 1080H851.433C872.13 1058.38 893.2 1036.02 914.637 1012.92ZM99.6357 1080H271.015C286.19 1040.83 301.97 1000.53 317.927 959.783L317.941 959.748C354.832 865.543 392.667 768.924 426.17 678.217C465.393 572.025 499.003 472.838 514.026 401.982C520.809 369.99 527.24 329.523 519.515 295.439C515.341 277.023 503.432 245.166 469.232 227.074C435.314 209.131 402.251 216.826 384.128 223.699C347.734 237.504 303.084 265.727 259.404 296.43C213.818 328.473 162.659 368.031 111.524 409.412C73.7012 440.02 35.4814 471.957 -1 503.096V715.307C59.8838 661.152 137.031 594.598 212.175 533.789C257.407 497.186 301.293 463.166 340.093 435.363C324.704 487.164 302.588 551.014 276.08 622.783C245.229 706.312 208.499 800.223 171.893 893.814C147.131 957.125 122.426 1020.29 99.6357 1080Z'
        fill='url(#paint0_linear_628_279)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1667.38 1080H1486.3C1611.76 827.881 1769.87 675.604 1919 590.57V782.25C1834.43 846.617 1746.41 941.771 1667.38 1080Z'
        fill='url(#paint1_linear_628_279)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_628_279'
        x1='959'
        y1='0'
        x2='959'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2B0D4F' />
        <stop offset='1' stopColor='#4B0D29' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_279'
        x1='1702.65'
        y1='590.57'
        x2='1702.65'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1E0A36' />
        <stop offset='1' stopColor='#380B1F' />
      </linearGradient>
      <clipPath id='clip0_628_279'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
